import * as React from 'react';
import { Product, PRODUCT_CONFIG_MAP, ProductConfig } from '@journeyapps-platform/types-accounts';
import { getThemeForProduct, JourneyTheme } from '../../theme';
import { ThemeProvider } from '@emotion/react';

export const ProductContext = React.createContext<ProductConfig>(PRODUCT_CONFIG_MAP[Product.APP]);

export interface ContextProps {
  product: Product;
}

export const ProductContextWidget: React.FC<React.PropsWithChildren<ContextProps>> = (props) => {
  return (
    <ProductContext.Provider value={PRODUCT_CONFIG_MAP[props.product]}>
      <ThemeProvider theme={getThemeForProduct(props.product)}>{props.children}</ThemeProvider>
    </ProductContext.Provider>
  );
};
